<template>
  <div class="wrapper">
    <nav-header :title="$t('apply.name')" ref="nav" />
    <!-- loading -->
    <div class="loading-wrapper row-center" v-if="loadStatus == 'loading'">
      <md-activity-indicator type="roller" color="#1b6fdc" vertical>
        Loading...
      </md-activity-indicator>
    </div>
    <!-- load fail -->
    <div class="fail-wrapper row-center" v-else-if="loadStatus == 'fail'">
      <span class="fail-text">{{ errMsg }}</span>
    </div>
    <!-- load success -->
    <div class="success-wrapper" v-else-if="loadStatus == 'success'">
      <!-- 正在审核 -->
      <div class="status-wrapper col-center" v-if="status === 'applied'">
        <img src="@/images/status-waiting.svg" alt="Wait" class="icon" />
        <span class="text">
          {{ $t('apply.wait') }}
        </span>
        <span class="subtext">
          {{ $t('apply.waitInfo') }}
        </span>
        <md-button type="primary" @click="goBack">
          <span>{{ $t('common.back') }}</span>
        </md-button>
      </div>
      <!-- 审核成功 -->
      <div class="status-wrapper col-center" v-else-if="status === 'adopted'">
        <img src="@/images/status-success.svg" alt="Success" class="icon" />
        <span class="text">{{ $t('apply.success') }}</span>
        <md-button type="primary" @click="goBack">
          <span>{{ $t('common.back') }}</span>
        </md-button>
      </div>
      <!-- 未通过 -->
      <div class="status-wrapper col-center" v-else-if="status === 'fail'">
        <img src="@/images/status-failed.svg" alt="Failed" class="icon" />
        <span class="text">{{ $t('apply.tips.failed') }}</span>
        <md-button type="primary" @click="goBack">
          <span>{{ $t('common.back') }}</span>
        </md-button>
      </div>
      <!-- 无需申请 -->
      <div class="status-wrapper col-center" v-else-if="status === 'ndlich'">
        <img src="@/images/status-failed.svg" alt="Failed" class="icon" />
        <span class="text">{{ $t('apply.tips.ndlich') }}</span>
        <md-button type="primary" @click="goBack">
          <span>{{ $t('common.back') }}</span>
        </md-button>
      </div>
      <!-- 需申请 -->
      <div v-else>
        <md-field :key="current" :title="checkList[current].question">
          <md-radio-list
            v-model="selected[current]"
            :options="checkList[current].options"
          ></md-radio-list>
          <md-input-item
            v-if="current === 3 && selected[3] == 2"
            v-model.trim="inputValue"
            type="text"
            :placeholder="$t('apply.tips.tipsLsit[9]')"
            clearable
          ></md-input-item>
          <md-button
            :type="
              selected[current] === '' ||
              isSubmitting ||
              (current === 3 && selected[3] == 2 && inputValue.length < 2)
                ? 'disabled'
                : 'primary'
            "
            slot="footer"
            @click="goNext(current)"
          >
            <md-activity-indicator
              type="carousel"
              color="currentColor"
              v-if="isSubmitting"
            />
            <span v-else>{{ $t('common.confirm') }}</span>
          </md-button>
        </md-field>
      </div>
    </div>
    <md-popup v-model="isPopupShow" :mask-closable="false" preventScroll>
      <div class="popup-container">
        <h2 class="popup-header">{{ $t('apply.tips.tips') }}</h2>
        <div class="popup-content">
          <div>
            {{ $t('apply.tips.title') }}
          </div>
            <i18n path="apply.tips.tipsLsit[3]" tag="p" v-if="!hasKyc">
            </i18n>
            <i18n path="apply.tips.tipsLsit[4]" tag="p" v-if="needAdvKyc">
            </i18n>
            <i18n
              path="apply.tips.tipsLsit[5]"
              tag="p"
              v-if="!hasRegistered60d"
            >
            </i18n>
            <p v-if="!hasOrder">
              {{ $t('apply.tips.tipsLsit[7]') }}
            </p>
        </div>
        <div class="popup-footer">
          <md-button type="primary" @click="goBack">
            <span>{{ $t('common.known') }}</span>
          </md-button>
        </div>
      </div>
    </md-popup>
  </div>
</template>

<script>
import navHeader from '@/components/the-nav-bar.vue';
import {
  ActivityIndicator,
  Popup,
  Button,
  Field,
  RadioList,
  InputItem,
  Icon,
  Dialog,
} from 'mand-mobile';
import getLandunStatus from '@/api/get-lundun-status';
import postLandun from '@/api/post-landun.js';
export default {
  components: {
    navHeader,
    [ActivityIndicator.name]: ActivityIndicator,
    [Popup.name]: Popup,
    [Button.name]: Button,
    [Field.name]: Field,
    [RadioList.name]: RadioList,
    [InputItem.name]: InputItem,
    [Icon.name]: Icon,
  },
  data() {
    return {
      loadStatus: 'loading',
      hasKyc: false, // 是否是已实名用户
      needAdvKyc: false, // 是否需要高级认证
      hasRegistered60d: false, // 是否注册  60 天
      hasOrder: false, // 是否已经体验过tiga

      status: 'no', // no 未申请 / applied 已申请待审核 / adopted 已通过 / fail 拒绝 / ndlich 无需申请

      errMsg: '',

      selected: ['', '', '', ''],
      current: 0,

      isPopupShow: false,
      isSubmitting: false,
      isQAShow: true,
      inputValue: '',
    };
  },
  computed: {
    checkList() {
      // 问题对应的长度
      return [3, 3, 4, 3].map((v, i) => {
        return {
          question: this.$t(`apply.QAs[${i}].question`),
          options: new Array(v).fill('').map((val, j) => {
            return {
              value: '' + j,
              text: this.$t(`apply.QAs[${i}].options[${j}]`),
            };
          }),
        };
      });
    },
  },
  mounted() {
    this.loadStatus = 'loading';
    getLandunStatus()
      .then(data => {
        const d = data.data;
        this.hasKyc = d.hasKyc;
        this.needAdvKyc = d.advKycLevel < 0;
        this.hasOrder = d.orderCount > 0;
        this.hasRegistered60d = d.registerSixtyDays;
        this.status = d.status;
        if (
          this.status == 'no' &&
          (!this.hasKyc ||
            this.needAdvKyc ||
            !this.hasOrder ||
            !this.hasRegistered60d)
        ) {
          this.isPopupShow = true;
        } else {
          this.loadStatus = 'success';
        }
      })
      .catch(err => {
        this.loadStatus = 'fail';
        this.errMsg = err.message;
      });
  },
  methods: {
    goBack() {
      this.$refs.nav && this.$refs.nav.goBack();
    },
    goNext(current) {
      switch (String(current)) {
        case '0':
          if (this.selected[0] == '0') {
            //
            this.onSubmit('ndlich');
          } else {
            this.current = 1;
          }
          break;
        case '1':
          if (this.selected[1] == '2') {
            this.current = 2;
          } else {
            this.current = 3;
          }
          break;
        case '2':
          if (this.selected[2] == '1' || this.selected[2] == '2') {
            //
            this.onSubmit('fail');
          } else {
            this.current = 3;
          }
          break;
        case '3':
          //
          this.onSubmit();
          break;
      }
    },
    onSubmit(status = '') {
      this.isSubmitting = true;
      const map = {
        0: 'A',
        1: 'B',
        2: 'C',
        3: 'D',
      };
      const questionnaire = this.selected.map(val => {
        if (val) {
          return map[val];
        }
        return '';
      });
      questionnaire.push(this.inputValue);
      postLandun({ questionnaire, status })
        .then(() => {
          return getLandunStatus().then(data => {
            const d = data.data;
            this.status = d.status;
            this.isSubmitting = false;
          });
        })
        .catch(err => {
          this.isSubmitting = false;
          Dialog.alert({
            icon: 'fail',
            title: this.$t('error.occur'),
            content: err.message,
          });
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.loading-wrapper {
  min-height: 80vw;
}

.fail-wrapper {
  min-height: 40vw;
  color: color-text-caption;
}

.success-wrapper {
  position: relative;
  padding-bottom: 30vw;

  .md-field {
    padding-top: 9.6vw;

    & >>> {
      .md-field-header {
        margin-bottom: 6.4vw;
      }

      .md-field-footer {
        margin-top: 9.6vw;
      }

      .md-field-title {
        line-height: 1.5;
      }

      .md-cell-item-body:before {
        content: none;
      }

      .md-cell-item-title {
        font-size: 3.73vw;
      }

      .md-radio.is-checked .md-radio-icon {
        color: color-primary;
      }
    }

    .md-button {
      margin-left: auto;
      margin-right: auto;
      width: 60vw;

      & >>> .md-activity-indicator-svg {
        width: 16vw !important;
        height: 4vw !important;
      }
    }
  }
}

.status-wrapper {
  min-height: 80vw;

  .md-icon, .icon {
    font-size: 16vw;
    width: 16vw;
    height: 16vw;
  }

  .text {
    margin-top: 9.6vw;
    font-size: 4.8vw;
  }

  .subtext {
    margin: 2.13vw 9.6vw 0;
    text-align: center;
  }

  .md-button {
    margin-top: 14.4vw;
    width: 60vw;
  }
}

.popup-container {
  box-sizing: border-box;
  width: 80.8vw;
  padding: 6.4vw 4.8vw;
  border-radius: 4.8vw;
  background: #fff;

  .popup-header {
    margin: 0;
    text-align: center;
  }

  .popup-content {
    margin: 4.8vw 0;
    font-size: 3.73vw;
    line-height: 1.5;

    p {
      margin-top: 2.13vw;
    }

    p:before {
      content: '';
      display: inline-block;
      margin-right: 2.13vw;
      width: 1.6vw;
      height: 1.6vw;
      border-radius: 50%;
      font-size: inherit;
      line-height: 1.5;
      vertical-align: middle;
      background: color-primary;
    }

    .link {
      color: #2F86F6;
    }
  }

  .popup-footer {
    margin: 0 auto;
    width: 60vw;
  }
}
</style>
